import { useTask } from "@/contexts/appContent/appContentHooks";
import { cn } from "@/lib/utils";
import { TaskId, TaskType } from "@/types/content-types";
import { forwardRef, Fragment } from "react";

export type TaskToggleBaseInfo = {
    content?: {
        text?: string,
        Icon?: React.ComponentType<{ className: string }>
    }[];
    sizeVariant: "wide" | "small";
};

export type TaskToggleInfo = TaskToggleBaseInfo & {
    type: TaskType,
};

type TaskToggleProps = TaskToggleBaseInfo & {
    taskId: TaskId;
    isUnlocked: boolean;
    isCompletedOverride?: boolean;
    isSelected?: boolean;
    onClick?: (event: React.MouseEvent) => void;
};

const TaskToggle = forwardRef<HTMLDivElement, TaskToggleProps>(({ taskId, content, sizeVariant, isCompletedOverride, isUnlocked, isSelected = false, onClick }, ref) => {
    const { completed } = useTask({ taskId });
    // console.log("isCompleted", task?.type, completed);
    return (
        <div
            ref={ref}
            className={cn(
                "flex items-center p-3 rounded-lg transition-all duration-300",
                sizeVariant === "small" ? "flex-col gap-1" : "justify-center w-full gap-2",
                isUnlocked && "cursor-pointer hover:bg-step-current/10",
                isCompletedOverride ?? completed
                    ? "bg-success/10 text-success border border-success/20"
                    : isUnlocked
                        ? "bg-muted/50 text-muted-foreground border border-border"
                        : "bg-muted/30 text-muted-foreground/50 border border-muted",
                isSelected && "bg-step-current/10",
            )}
            onClick={(e) => isUnlocked && onClick(e)}
        >
            {
                content.map((item, index) => (
                    <Fragment key={index}>
                        {item.Icon && <item.Icon className="w-4 h-4" />}
                        {item.text && <span className="text-xs font-medium text-center">{item.text}</span>}
                    </Fragment>
                ))
            }
        </div>
    );
});

export { TaskToggle };